import React from "react";
import { useForm } from "react-hook-form";
import { RouteComponentProps } from "react-router";

import { Card, CardBody } from '../components/wombat-ui/components/Card';
import Button from '../components/wombat-ui/components/Button';
import Input from '../components/wombat-ui/components/Form/Input';

import Logo from "../components/Logo";
import useTranslations from "../hooks/useTranslations";
import useAddNotification from "../hooks/useAddNotification";

import useUserSendPasswordReset from "../graphql/hooks/mutations/useUserSendPasswordReset";

type ForgottenPassswordFormData = {
  email: string;
};

type ForgottenPasswordScreenProps = {} & RouteComponentProps<{}>;

const ForgottenPasswordScreen: React.FC<ForgottenPasswordScreenProps> = () => {
  const t = useTranslations();
  const [addNotification] = useAddNotification();
  const { register, handleSubmit, setValue } = useForm<ForgottenPassswordFormData>();

  const [ userSendPasswordReset ] = useUserSendPasswordReset();
  const onSubmit = handleSubmit(async ({ email }) => {
    try {
      await userSendPasswordReset({
        variables: {
          email,
          redirectUrl: `${window.location.protocol}//${window.location.host}/profile/update-password`
        }
      });
      addNotification({
        variables: {
          title: t("forgottenPassword.sendSuccessTitle") as string,
          body: t("forgottenPassword.sendSuccessBody") as string,
          status: "success",
        },
      });
      setValue('email', '');
    } catch (error) {
      addNotification({
        variables: {
          title: t("forms.errors.notificationTitle") as string,
          body: t("forms.errors.emailOrPassword") as string,
          status: "error",
        },
      });
    }
  });

  return (
    <div className="flex flex-col justify-center min-h-screen py-12 bg-gray-50 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex flex-row justify-center">
          <Logo />
        </div>
        <h2 className="mt-6 text-2xl font-extrabold text-center text-dark-300">
          {t("forgottenPassword.forgottenPassword")}
        </h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <Card>
          <CardBody>
            <form className="px-2 space-y-6" onSubmit={onSubmit} id="forgottenPasswordForm">
              <Input
                id="email"
                label={t("forms.fields.email")}
                name="email"
                type="email"
                autoComplete="email"
                required
                ref={register({ required: true })}
              />

              <Button type="submit" block>
                {t("forms.actions.send")}
              </Button>
            </form>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default ForgottenPasswordScreen;
